import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { ReactComponent as ChevronLeftIcon } from "components/Icons/chevron-left.svg";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useNavigate } from "react-router-dom";
import { OLStyledIcon } from "./OLStyledIcon";

type Props = {
  className?: string;
  link: string;
  "data-test-id"?: string;
};

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    icon: {
      margin: theme.spacing(0, 4, 0, 0),
      "[dir='rtl'] &": {
        transform: "rotate(180deg)",
      },
    },
  }),
);

export function OLBackIcon({
  className = "",
  link = "",
  "data-test-id": dataTestId,
}: Props) {
  const navigate = useNavigate();
  const classes = useStyles();

  return (
    <OLStyledIcon
      className={`${classes.icon} ${className}`}
      Icon={ChevronLeftIcon}
      onClick={() => {
        link && navigate(link);
      }}
      data-test-id={dataTestId}
    />
  );
}
